// Tabla.tsx
import React from 'react';

import { styles } from './style';
import Constants from '../../constants';
import CommonTable, { Column } from '../commonTable';
import Card from '../card';
import { Badge } from 'react-bootstrap';
import Utils from '../../utils/utils';
import EnrollmentNotesTimeline from '../enrollment/enrollmentNotesTimeline';
import TiraDeMeses, { leyendaTira } from '../acuerdos/tiraDeMeses';
import { horasAmPm } from "../../utils/fechaHoraAmPm";

export interface AccountStatementCardProps extends React.HTMLAttributes<HTMLDivElement> {
    /**
     * Columns to show in the Table
     */
    columns: Column[];
    /**
     * Data to show in the Table
     */
    data: any;
}

const AccountStatementCard: React.FC<AccountStatementCardProps> = ({ columns, data }) => {

    /*
        AQUI SE ESCONDIA LA INSCRIPCION EN CERO, Y SE DESHIZO EL 2026-09-21.

        La idea era limpiar: una inscripcion gratis dejaba un renglon con L0.00 en
        las tres columnas y hacia dudar de si faltaba algo por pagar. Pero en caja
        ese renglon se usa: Katerin (Tegucigalpa) lo selecciona para ponerle las
        observaciones del cobro, y sin el no podia registrar la matricula. Ademas
        el renglon seguia entrando al carrito aunque ya no se viera, asi que
        aparecia un concepto que no se podia entender ni quitar desde la lista.

        Esconder algo que se sigue usando por detras es peor que el renglon feo.
        Si se quiere volver a limpiar, hay que sacarlo TAMBIEN del carrito, y eso
        ya es tocar el cobro.
    */

    return (
        <React.Fragment > {data ?
            <Card>
                <section style={{
                    ...styles.header,
                    flexDirection: "column"
                }}>
                    <div style={{
                        marginLeft: "7px",
                        display: "flex",
                        justifyContent: "flex-end"
                    }}>
                        <div style={{
                            display: "flex",
                            paddingRight: "20px",
                            flexDirection: "column"
                        }}>
                            <div style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                paddingRight: "20px"
                            }}>
                                <Badge bg={Utils.renderStatusEnrollment(data.enrollmentStatusId)}>
                                    {data.enrollmentStatus}
                                </Badge>
                            </div>

                        </div>
                    </div>
                    <div style={{
                        marginLeft: "7px",
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        <p style={{
                            ...styles.subtitle,
                            margin: 0
                        }}>
                            {Constants.Common.course}:
                        </p>
                        <h3 style={styles.courseText}>
                            {data.courseName}
                        </h3>
                    </div>
                </section>
                <section style={{
                    marginBottom: 10,
                    marginLeft: "25px",
                    display: "inline-flex",
                    alignItems: "stretch",
                    flexFlow: "wrap"
                }}>
                    <div style={{ flexGrow: 1 }}>
                        <div style={{
                            display: "flex",
                            alignItems: "stretch",
                            flexFlow: "wrap"
                        }}>
                            <div style={{ flexGrow: 1 }}>
                                <div style={{
                                    ...styles.subtitleContainer,
                                    alignItems: "stretch"
                                }}>
                                    <div style={{ ...styles.subtitle }}>
                                        {Constants.Common.level}:
                                    </div>
                                    <div style={{ ...styles.boldText }}>
                                        {data.levelName}
                                    </div>
                                </div>
                            </div>
                            <div style={{ flexGrow: 1 }}>
                                <div style={{
                                    ...styles.subtitleContainer,
                                    alignItems: "stretch"
                                }}>
                                    <div style={{ ...styles.subtitle }}>
                                        {Constants.Common.period}:
                                    </div>
                                    <div style={{ ...styles.periodText }}>
                                        {data.periodName}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                        <div style={{
                            display: "flex",
                            alignItems: "stretch",
                            flexFlow: "wrap"
                        }}>
                            <div style={{ flexGrow: 1 }}>
                                <div style={{
                                    ...styles.subtitleContainer,
                                    alignItems: "stretch"
                                }}>
                                    <div style={{ ...styles.subtitle }}>
                                        {Constants.Common.scheduleCode}:
                                    </div>
                                    <div style={{ ...styles.boldText }}>
                                        {data.scheduleCode}
                                    </div>
                                </div>
                            </div>
                            <div style={{ flexGrow: 1 }}>
                                <div style={{
                                    ...styles.subtitleContainer,
                                    alignItems: "stretch"
                                }}>
                                    <div style={{ ...styles.subtitle }}>
                                        {Constants.Common.schedule}:
                                    </div>
                                    <div style={{ ...styles.boldText }}>
                                        {horasAmPm(data.schedules)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section style={{
                    margin: "0 25px 14px 25px",
                    padding: "10px 16px",
                    background: "var(--wa-papel-3)",
                    borderLeft: "3px solid var(--main-color, var(--wa-acento))",
                    borderRadius: "6px",
                    textAlign: "left"
                }}>
                    <EnrollmentNotesTimeline
                        notes={data.enrollmentNotesHistory || []}
                        createdAt={data.enrollmentCreatedAt}
                        createdBy={data.enrollmentCreatedBy}
                        advisors={data.enrollmentAdvisors || []}
                        legacyNotes={data.enrollmentNotes}
                        statusId={data.enrollmentStatusId}
                        status={data.enrollmentStatus}
                        updatedAt={data.enrollmentUpdatedAt}
                        updatedBy={data.enrollmentUpdatedBy}
                    />
                </section>
                {/* Acuerdo comercial de la matrícula (Etapa 3 de cobros): promo, con quién, condición y la tira de meses. */}
                {data.agreementStrip ? (
                    <section style={{ margin: "0 25px 14px 25px", textAlign: "left" }}>
                        {data.agreementStrip.agreements.map((a: any) => (
                            <div key={"ag" + a.id} style={{ fontSize: 14 }}>
                                <b>Acuerdo «{a.name}»</b>
                                <span style={{ marginLeft: 6, fontSize: 12, fontWeight: 700, padding: "1px 7px", borderRadius: 999,
                                    background: a.statusId === 2 ? "var(--wa-oro-suave)" : "var(--wa-acento-suave)", color: a.statusId === 2 ? "var(--wa-oro)" : "var(--wa-acento-texto)" }}>{a.status}</span>
                                {a.members && a.members.length ? <span style={{ color: "var(--wa-apagado)" }}> · con {a.members.map((m: any) => m.name).join(", ")}</span> : null}
                                {a.requestId ? <span style={{ color: "var(--wa-apagado)" }}> · solicitud #{a.requestId}</span> : null}
                                {a.conditionText ? <div style={{ fontSize: 13, color: "var(--wa-oro)" }}>{a.conditionText}</div> : null}
                            </div>
                        ))}
                        <TiraDeMeses meses={data.agreementStrip.months.map((m: any) => ({ n: m.n, title: m.title, state: m.state, subTotal: m.subTotal, list: m.listAmount, note: m.note }))} compacta />
                        <div style={{ fontSize: 11, color: "var(--wa-apagado)" }}>{leyendaTira}</div>
                    </section>
                ) : null}
                {/* En telefono las ocho columnas pasan a una tarjeta por mensualidad. */}
                <CommonTable
                    columns={columns}
                    data={data.tuitions}
                    tarjetasEnTelefono
                />
                <div className="cardFooter">
                    <section style={styles.totalSection}>
                        <div style={styles.totalContainer}>
                            <div style={styles.totalText}>
                                {Constants.Screens.Finances.accountStatement.total}:
                            </div>
                            <div
                                style={{
                                    ...styles.totalTextNumber,
                                    paddingLeft: "15px",
                                    color: data.pendingAmountTotal.value === 0 ? "var(--wa-tinta)" : "var(--wa-rojo)"
                                }}>
                                {data.pendingAmountTotal.moneyFormat}
                            </div>
                        </div>
                    </section>
                </div>
            </Card>
            :
            <Card>
                <div style={{ ...styles.header }}>
                    <p>Sin registros</p>
                </div>
            </Card>
        }
        </React.Fragment>
    )
}

export default AccountStatementCard;
